import { render } from "./SingleRadioComponent.vue?vue&type=template&id=2611366a&scoped=true&ts=true"
import script from "./SingleRadioComponent.vue?vue&type=script&lang=ts"
export * from "./SingleRadioComponent.vue?vue&type=script&lang=ts"

import "./SingleRadioComponent.vue?vue&type=style&index=0&id=2611366a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/SurveyPublic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2611366a"]])

export default __exports__